module.exports = __webpack_public_path__ + "img/bingo_ball-34.b1ddf9bd.png";